import { render, staticRenderFns } from "./PdfMake.vue?vue&type=template&id=08bed7df&scoped=true&"
import script from "./PdfMake.vue?vue&type=script&lang=js&"
export * from "./PdfMake.vue?vue&type=script&lang=js&"
import style0 from "./PdfMake.vue?vue&type=style&index=0&id=08bed7df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bed7df",
  null
  
)

export default component.exports